import { createApp } from "vue";
import { createPinia } from "pinia";
import ArcoVue from "@arco-design/web-vue";

/* 样式加载顺序在这里是有意义的，不要随意调整：
   1. arco.css         组件库原始样式（提供所有默认值）
   2. tokens.css       站点设计令牌，定义 --km-*
   3. arco-bridge.css  把 --km-* 映射进 Arco 的变量命名空间，覆盖上一步的默认值
   4. base.css         元素基线、排版与布局工具类
   5. theme-compat.css 历史页面的表面收敛（随页面改造逐步缩减）
   顺序错了会导致 Arco 默认值把站点配色盖回去。 */
import "@arco-design/web-vue/dist/arco.css";
import "@/styles/tokens.css";
import "@/styles/arco-bridge.css";
import "@/styles/base.css";
import "@/styles/theme-compat.css";

import App from "./App.vue";
import router from "./router";
import "@/access";
import { initializeTheme } from "@/composables/useTheme";

initializeTheme();

createApp(App).use(ArcoVue).use(createPinia()).use(router).mount("#app");
